module.exports = __webpack_public_path__ + "img/wordpress.41a48ac8.png";